// Simple form script

// Justin James
// Last Edit: 31-12-2012

var checkoutform = {
    reqFieldsMessage : "Please fill in all required fields to continue.",
    termsMessage : "Please agree to our Terms and Policy to continue.",
    optoMessage : "Please authorize the release of your eyeglasses prescription, including lens type, from the optometrist to See.Saw.Seen Eyewear."
};

checkoutform.toggle = function () {
    var ele = document.getElementsByName('prescription-control');
    var i = ele.length;
    for (var j = 0; j < i; j++) {
        if (ele[j].checked) {
            $("#" + ele[j].id + "-field").slideDown(600);
        }
        else {
            $("#" + ele[j].id + "-field").slideUp(600);
        }
    }
};

checkoutform.gatherDetails = function(){
        $("#prescription-supplied").val(""); // clear all attributes
        $("#customer-name").val("");
        $("#cust-dob").val("");
        $("#cust-phone").val("");
        $("#cust-scripttype").val("");
        $("#cust-righteye").val("");
        $("#cust-lefteye").val("");
        $("#cust-pd").val("");
        $("#cust-expiry").val("");
        $("#cust-optometrist").val("");
        $("#cust-optometristphone").val("");

    if ($("#prescription-control-contact").is(':checked')){
        $("#prescription-supplied").val("Optometrist will be contacted for prescription details");
        $("#customer-name").val($("#contact-surname").val() + ", " + $("#contact-firstname").val() + " " + $("#contact-midname").val());
        $("#cust-dob").val($("#contact-dob").val());
        $("#cust-phone").val("ph. " + $("#contact-number").val() + "  email. " + $("#contact-email").val());
        $("#cust-optometrist").val($("#contact-optoname").val());
        $("#cust-optometristphone").val("ph. " + $("#contact-optonumber").val() + "  add. " + $("#contact-optoaddress").val());
    } else if ($("#prescription-control-fax").is(':checked')) {
        $("#prescription-supplied").val("Prescription will be faxed/emailed");
    } else if ($("#prescription-control-enter").is(':checked')){
        $("#prescription-supplied").val("Prescription is supplied");
        $("#customer-name").val($("#enter-surname").val() + ", " + $("#enter-firstname").val() + " " + $("#enter-midname").val());
        $("#cust-dob").val($("#enter-dob").val());
        $("#cust-scripttype").val($('#enter-type').val());
        $("#cust-righteye").val("sph: " + $('#right_rx_id').val() + "  cyl: " + $('#right_cyl_id').val() + "  axis: " + $('#right_axis_id').val() + "  add: " + $('#right_add_id').val());
        $("#cust-lefteye").val("sph: " + $('#left_rx_id').val() + "  cyl: " + $('#left_cyl_id').val() + "  axis: " + $('#left_axis_id').val() + "  add: " + $('#left_add_id').val());
        $("#cust-pd").val("Binocular PD: " + $('#pd_id').val() + " - Monocular PD: right: " + $('#right_pd_id').val() + " left: " + $('#left_pd_id').val());
        $("#cust-expiry").val($("#enter-expire").val());
        $("#cust-optometrist").val($("#enter-optoname").val());
        $("#cust-optometristphone").val("ph. " + $("#enter-optonumber").val() + "  add. " + $("#enter-optoaddress").val());
    }
};

checkoutform.checkfields = function(sectionID){
    var formBlock = document.getElementById(sectionID);
    var reqFields = formBlock.getElementsByTagName('input');//getElementsByClassName("required-entry");
    var pass = true;
    if (reqFields){
        var j = reqFields.length;
        for (var i = 0; i < j; i++){
            if($(reqFields[i]).hasClass("required-entry")){
                var x = reqFields[i].value;
                if (    x == null || 
                        x == "" ||
                        x == "Last Name" ||
                        x == "First Name" ||
                        x == "MM/DD/YYYY" ||
                        x == "Optometrist Name" ||
                        x == "Optometrist Number" ||
                        x == "your@email.com" ||
                        x == "Phone Number"){ //check its not blank or the placeholder text
                    $(reqFields[i]).addClass("reqError");
                    pass = false;
                } else {
                   $(reqFields[i]).removeClass("reqError");
                }
            }
        }
    }
    return pass;
};

checkoutform.checkagreements = function () {
    var allGoodTerms = false; // if the T&Cs are checked then they are "all good"
    if ($('#tc-agree').is(':checked')) {
        allGoodTerms = true;
    }

    var allGoodPrescription = false; // if agree to the access of the prescription from the Optometrist then they are "all good"
    var allGoodReqFields = false;
    if ($("#prescription-control-contact").is(':checked')){
        if (checkoutform.checkfields("prescription-control-contact-field")){
            allGoodReqFields = true;
        }
        if ($("#contact-opto-agree").is(':checked')){
            allGoodPrescription = true; 
        }
    } else if ($("#prescription-control-fax").is(':checked')) {
        allGoodPrescription = true;
        allGoodReqFields = true;
    } else if ($("#prescription-control-enter").is(':checked')){
        if (checkoutform.checkfields("prescription-control-enter-field")){
            allGoodReqFields = true;
        }
        if ($("#enter-opto-agree").is(':checked')){
            allGoodPrescription = true;
        }
    }


    if (allGoodReqFields && allGoodTerms && allGoodPrescription) { // if both are "all good" then proceed
        checkoutform.gatherDetails();
        return true;
    } else { // otherwise alert that something is needs checking
        if (!allGoodReqFields){
            alert(checkoutform.reqFieldsMessage);
        } else if (!allGoodTerms){
            alert(checkoutform.termsMessage);
        } else if (!allGoodPrescription){
            alert(checkoutform.optoMessage);
        }
        return false;
    }
};